import { Button, InputAdornment, TextField } from "@material-ui/core";
import { Email, Person, VpnKey } from "@material-ui/icons";
import FatButton from "common/components/FatButton/FatButton";
import { SetLoading } from "common/components/Loader/Loader";
import ModalHelper from "common/helpers/modalHelper";
import UserManager from "common/userManager";
import React, { useState } from "react";
import FormError from "./FormError";
import { useAuthStyles } from "./styles";

export default function RegisterForm({ onSwitchToLogin }) {
	const styles = useAuthStyles();
	const [username, setUsername] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [fieldErrors, setFieldErrors] = useState({});
	const [formError, setFormError] = useState(null);

	const onSubmit = (event) => {
		event.preventDefault();
		setFormError(null);
		setFieldErrors({});

		const values = {
			username: username.trim(),
			email: email.trim(),
			password: password.trim(),
			confirmPassword: confirmPassword.trim(),
		};

		if (Object.values(values).some((value) => value.length === 0)) {
			setFormError("Please fill in all fields");
			return;
		}

		SetLoading(true, "Creating Account...");
		UserManager.register(
			values.username,
			values.email,
			values.password,
			values.confirmPassword
		)
			.then((result) => {
				SetLoading(false);

				if (
					result.usernameError ||
					result.emailError ||
					result.passwordError ||
					result.confirmPasswordError
				) {
					setFieldErrors({
						username: result.usernameError,
						email: result.emailError,
						password: result.passwordError,
						confirmPassword: result.confirmPasswordError,
					});
					return;
				}

				UserManager.login(values.username, values.password)
					.then(() => {
						ModalHelper.closeModal();
						UserManager.redirectAfterLogin();
					})
					.catch(() => {
						onSwitchToLogin("Account created. Please log in.");
					});
			})
			.catch((err) => {
				SetLoading(false);
				if (!err || !err.status) {
					setFormError("Could not reach the server. Please try again.");
				}
			});
	};

	return (
		<form onSubmit={onSubmit}>
			<TextField
				id="username"
				className={styles.field}
				label="Username"
				value={username}
				onChange={(e) => setUsername(e.target.value)}
				variant="outlined"
				fullWidth
				autoFocus
				autoComplete="username"
				error={!!fieldErrors.username}
				helperText={fieldErrors.username}
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<Person />
						</InputAdornment>
					),
				}}
			/>
			<TextField
				id="email"
				className={styles.field}
				label="Email"
				type="email"
				value={email}
				onChange={(e) => setEmail(e.target.value)}
				variant="outlined"
				fullWidth
				autoComplete="email"
				error={!!fieldErrors.email}
				helperText={fieldErrors.email}
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<Email />
						</InputAdornment>
					),
				}}
			/>
			<TextField
				id="password"
				className={styles.field}
				label="Password"
				type="password"
				value={password}
				onChange={(e) => setPassword(e.target.value)}
				variant="outlined"
				fullWidth
				autoComplete="new-password"
				error={!!fieldErrors.password}
				helperText={fieldErrors.password}
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<VpnKey />
						</InputAdornment>
					),
				}}
			/>
			<TextField
				id="confirmpassword"
				className={styles.field}
				label="Confirm Password"
				type="password"
				value={confirmPassword}
				onChange={(e) => setConfirmPassword(e.target.value)}
				variant="outlined"
				fullWidth
				autoComplete="new-password"
				error={!!fieldErrors.confirmPassword}
				helperText={fieldErrors.confirmPassword}
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<VpnKey />
						</InputAdornment>
					),
				}}
			/>

			<FormError message={formError} />

			<FatButton
				text="Create Account"
				type="submit"
				primary
				className={styles.submit}
			/>
			<Button
				className={styles.secondary}
				onClick={() => onSwitchToLogin(null)}
			>
				Already have an account? Log in
			</Button>
		</form>
	);
}
